/** Where a video stood when its signed link failed, so a retry can continue from that point. */
export function playbackPoint(media) {
  if (media.tagName !== 'VIDEO' || !media.getAttribute('src') || !(media.currentTime > 0)) return null;
  return { time: media.currentTime, playing: !media.paused && !media.ended };
}

/** A new src reloads the element from the start, so the point is applied once the new link has loaded. */
export function setSource(media, url, point) {
  if (point) {
    media.addEventListener('loadedmetadata', () => {
      media.currentTime = point.time;
      if (point.playing) media.play()?.catch(() => {});
    }, { once: true });
  }
  media.src = url;
}
